import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const EmployeeList = lazy(() => import('@/features/employees/list/page'));
const FormerEmployeesList = lazy(() => import('@/features/employees/former/page'));
const EmployeeSearch = lazy(() => import('@/features/employees/search/page'));
const EmployeeEdit = lazy(() => import('@/features/employees/edit/page'));

export const employeesRoutes: RouteObject[] = [
  { path: 'employees', element: <EmployeeList /> },
  { path: 'employees/former', element: <FormerEmployeesList /> },
  { path: 'employees/search', element: <EmployeeSearch /> },
  { path: 'employees/:id/edit', element: <EmployeeEdit /> },
];
